/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'trash': {
    width: 21,
    height: 21,
    viewBox: '0 0 21 21',
    data: '<path pid="0" d="M2.722 20.763a1.414 1.414 0 01-.125-.125c.045.045.083.09.125.125zm-.227-.128zm18.28-17.367a.885.885 0 00-.616-.248h-4.321V1.674c0-.91-.74-1.65-1.65-1.65H6.81c-.91 0-1.65.74-1.65 1.65V3.02H.818a.839.839 0 000 1.676h.74v14.587c0 .91.74 1.65 1.65 1.65h14.818c.91 0 1.65-.74 1.65-1.65V4.696h.483c.46 0 .861-.374.861-.838a.825.825 0 00-.245-.59zM6.808 1.678h7.372v1.356H6.808V1.68zm11.216 17.603H3.208V4.696h14.815v14.585h.001zM10.488 7.505a.842.842 0 00-.842.843v7.819a.842.842 0 101.685 0v-7.82a.842.842 0 00-.843-.842zm-4.564 0a.842.842 0 00-.843.843v7.819a.842.842 0 101.685 0v-7.82a.843.843 0 00-.842-.842zm9.082 0a.842.842 0 00-.842.843v7.819a.842.842 0 101.685 0v-7.82a.842.842 0 00-.843-.842z" _fill="#FFF" fill-rule="nonzero"/>'
  }
})
